import { Eyebrow, Reveal } from "@/components/ui-bits";

const PRINCIPLES = [
  {
    number: "01",
    title: "RELIABILITY",
    desc: "Dependable coordination, clear expectations, and consistent follow-through from pickup through delivery.",
  },
  {
    number: "02",
    title: "COMMUNICATION",
    desc: "Responsive communication that keeps customers informed and issues addressed before they become problems.",
  },
  {
    number: "03",
    title: "TRANSPARENCY",
    desc: "Straightforward transportation coordination with clear information and practical expectations.",
  },
  {
    number: "04",
    title: "VALUE",
    desc: "Transportation solutions selected around the shipment, the requirement, and what makes business sense.",
  },
];

const Approach = () => {
  return (
    <section data-testid="approach-section" aria-labelledby="approach-heading" className="border-t border-[#e5e7eb] bg-[#f7f8f9] py-16 sm:py-20 lg:py-24">
      <div className="container-30">
        <Reveal className="max-w-3xl">
          <Eyebrow>The 30 NORTH Approach</Eyebrow>
          <h2
            id="approach-heading"
            data-testid="approach-headline"
            className="mt-6 text-3xl font-extrabold leading-[1.08] tracking-tight text-[#191c1e] sm:text-4xl"
          >
            EXPERIENCE THAT TRANSLATES INTO BETTER EXECUTION.
          </h2>
          <p className="mt-6 text-base leading-relaxed text-[#5f666d] sm:text-lg">
            Our experience across logistics, supply chain, large 3PL operations, and asset-based transportation has
            shaped how we work: understand the requirement, coordinate the right solution, communicate clearly, and
            follow through.
          </p>
        </Reveal>

        <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:mt-14" data-testid="approach-principles">
          {PRINCIPLES.map((p, i) => (
            <Reveal key={p.number} delay={i * 0.07} className="h-full">
              <div
                data-testid={`principle-${p.number}`}
                className="flex h-full flex-col border border-[#e5e7eb] bg-white p-7 transition-all duration-300 hover:-translate-y-1 hover:border-[#191c1e] hover:shadow-[0_20px_40px_-24px_rgba(25,28,30,0.3)] lg:p-8"
              >
                <div className="flex items-center gap-4">
                  <span className="font-display text-2xl font-extrabold text-[#ff6a00]">{p.number}</span>
                  <span className="block h-px flex-1 bg-[#e5e7eb]" aria-hidden="true" />
                </div>
                <h3 className="mt-5 font-display text-lg font-bold tracking-wide text-[#191c1e]">{p.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-[#5f666d]">{p.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Approach;
